import React from "react";
import EmailUpdatesView from "./view";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { noop } from "@client/shared/constants";
import DeleteIcon from "@mui/icons-material/Delete";
import { globalStyles } from "@client/shared/constants";
import style from "./style";

const EmailUpdatesPanel = ({
  bbc = [],
  individualContactList = [],
  handleChange = noop,
  removeBBC = noop,
}) => {
  const columnConfig = [
    {
      id: "name",
      field: "name",
      label: "NAME",
      headerClassName: style.gridHeader,
      render: (row) => (
        <Tooltip title={row.name || ""} placement="top-start">
          <Typography noWrap variant="body2">
            {row.name || "-"}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "email",
      field: "email",
      label: "EMAIL",
      headerClassName: style.gridHeader,
      render: (row) => (
        <Tooltip title={row?.contact?.email || ""} placement="top-start">
          <Typography noWrap variant="body2">
            {row?.contact?.email || "-"}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "col-action",
      label: "",
      headerClassName: style.gridHeader,
      render: (row) => (
        <Box
          sx={{
            ...globalStyles.display.flex,
            ...globalStyles.flex.end,
          }}
        >
          <DeleteIcon
            onClick={() => removeBBC(row.id)}
            sx={{
              ...globalStyles.cursor.pointer,
            }}
          />
        </Box>
      ),
    },
  ];

  return (
    <EmailUpdatesView
      bbc={bbc}
      individualContactList={individualContactList}
      columnConfig={columnConfig}
      handleChange={handleChange}
    />
  );
};

export default EmailUpdatesPanel;
